export default __webpack_public_path__ + "static/media/NTT.39f9ed24.png";